import type { VisualEffect } from '../tilemap/types';

export class ArcSwingEffect implements VisualEffect {
  private elapsed = 0;
  private readonly duration = 0.24;
  private readonly centerX: number;
  private readonly centerY: number;
  private readonly rotation: number;
  private readonly tileToScreenCenter: (x: number, y: number) => { x: number; y: number };
  private readonly tileSize: number;
  private readonly sweepRadians: number;

  constructor(options: {
    centerX: number;
    centerY: number;
    rotation: number;
    tileToScreenCenter: (x: number, y: number) => { x: number; y: number };
    tileSize: number;
    sweepDegrees?: number;
  }) {
    this.centerX = options.centerX;
    this.centerY = options.centerY;
    this.rotation = options.rotation;
    this.tileToScreenCenter = options.tileToScreenCenter;
    this.tileSize = options.tileSize;
    this.sweepRadians = ((options.sweepDegrees ?? 120) * Math.PI) / 180;
  }

  update(deltaSeconds: number): void {
    this.elapsed += deltaSeconds;
  }

  renderOverlay(ctx: CanvasRenderingContext2D): void {
    const progress = Math.min(this.elapsed / this.duration, 1);
    const alpha = 1 - progress;
    const center = this.tileToScreenCenter(this.centerX, this.centerY);
    const radius = this.tileSize * (1.0 + progress * 0.2);
    const rotationRad = (this.rotation - 90) * (Math.PI / 180);
    const startAngle = rotationRad - this.sweepRadians / 2;
    const endAngle = rotationRad + this.sweepRadians / 2;

    ctx.save();
    ctx.globalAlpha = alpha;
    ctx.lineCap = 'round';

    ctx.beginPath();
    ctx.lineWidth = this.tileSize * 0.35;
    ctx.strokeStyle = 'rgba(255, 242, 204, 0.35)';
    ctx.arc(center.x, center.y, radius, startAngle, endAngle);
    ctx.stroke();

    ctx.beginPath();
    ctx.lineWidth = this.tileSize * 0.16;
    ctx.strokeStyle = 'rgba(255, 196, 92, 0.95)';
    ctx.arc(center.x, center.y, radius, startAngle, endAngle);
    ctx.stroke();
    ctx.restore();
  }

  isComplete(): boolean {
    return this.elapsed >= this.duration;
  }
}
